import request from '@/utils/request'

// 查询码上办-专利开放列表
export function listZlOld(query) {
  return request({
    url: '/web/msb/zlOld/list',
    method: 'get',
    params: query
  })
}
